import { useEffect, useState } from "react"
import { Box, Hidden, Divider } from "@mui/material"
import { useApiService } from "../hooks/Api/useApiService"
import SimilarSkills from "./SimilarSkills"
import FavoriteSkills from "./FavoriteSkills"
import Post from "../Post/Post"
import Feed from "../Feed/Feed"
import SharieCalendar from "../UI/SharieCalendar"
import useDeviceType from "../hooks/Utils/useDeviceType"
import T from "../hooks/Language/T"
import SavedSkills from "./SavedSkills"
import CombinedSkills from "./CombinedSkills"

const Skills = (props) => {
  const [skills, setSkills] = useState([])
  const [favorites, setFavorites] = useState([])
  const [finished_deleting, setFinishedDeleting] = useState(false)
  const { postData } = useApiService()
  const [scrollPercentage, setScrollPercentage] = useState(0)
  const deviceType = useDeviceType()
  const isDesktop = deviceType === "desktop"

  useEffect(() => {
    let endpoint = "skills/getskillsbyuser"
    let body = { user_name: props.user_name || localStorage.getItem("user") }

    postData(endpoint, body)
      .then((data) => {
        setSkills(data.skills)
      })
      .catch((error) => {})

    endpoint = "skills/getfavoriteskills"
    body = { user_name: props.user_name || localStorage.getItem("user") }

    postData(endpoint, body)
      .then((data) => {
        setFavorites(data.favorites)
      })
      .catch((error) => {})
  }, [props.user_name, finished_deleting])

  return (
    <T>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          width: "100%",
          maxWidth: "100vw",
          overflowX: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", sm: "50%" },
            padding: 2,
            boxSizing: "border-box",
          }}
        >
          <Post />
          {!isDesktop && <SharieCalendar />}

          <Feed scrollPercentage={scrollPercentage} user_name={localStorage.getItem("user")} />
        </Box>

        <Box
          sx={{
            width: "100%",
            padding: 2,
            boxSizing: "border-box",
          }}
        >
          {isDesktop && <SharieCalendar />}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <FavoriteSkills skills={favorites} />
            <SimilarSkills skills={skills} />
            <SavedSkills />
            <CombinedSkills skills={skills} />
          </Box>
        </Box>
      </Box>
    </T>
  )
}

export default Skills
